import styled from 'styled-components';
import {Modal} from "react-bootstrap";
const Bold = styled.div`
    font-family: Rubik;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 18px;
   text-align: center;
  margin-bottom: 25px;
   margin-top: 25px;
  color: #3A3A3A;
  .subContent {
    font-family: Rubik;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: #9C9C9C;
    margin-top: 5px;
  }
`;

const StyledModal = styled(Modal)`
  .modal-backdrop.in{
    opacity: .2;
  }
  .modal-dialog {
    transform: translate(-50%, -50%);
  }
  .delete-popup { 
    top: 30%;
    width: 400px;
    height: 90px;
    margin: 0 auto;
    .modal-header {
      border-bottom: 0px;
      background: linear-gradient( 
        180deg,#52A8ED 0%,#8AD3F7 100%);
      border-radius: 6px 6px 0 0;
    } 
  }
 @media (max-width: 500px){
   .modal-dialog {
    width: 80%;
    }
 }
`;

const SubmitContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .biometric-button {
    font-size: 16px;
  }
`;

const StyledModalV2 = styled(Modal)`
.modal-content{
  width: ${({ width }) => width ? width : ""};
  padding:16px;
}
  .modal-backdrop.in{
    opacity: .2;
  }
  .modal-dialog {
    transform: translate(-50%, -50%);
  }
  .delete-popup {
    width: 400px; 
    top: 30%;
    margin: 0 auto;
    .modal-header {
     border-bottom: 1px solid #EFEFEF;
      border-radius: 12px 12px 0 0;
      padding: 0 0 16px;
    } 
    .modal-body {
      padding:16px 0px;
    }

 
 @media (max-width: 500px){
   .modal-dialog {
    width: 80%;
    }
 }
`;

const BoldV2 = styled.div`
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: ${({ isFontSize }) => isFontSize ? isFontSize : "16px"};
    ${'' /* font-size: 18px; */}
    line-height: 18px;
    text-align: center;
    margin-bottom: 20px;
    ${'' /* margin-top: 25px; */}
    margin-top: ${({ isMargin }) => isMargin ? isMargin : "20px"};
    color: #184A61;
    >span{
      font-family: 'Lato';
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      margin-bottom: 25px;
      margin-top: 25px;
      color: #0D4270;
    }
  .subContent {
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #DA6C74;
    margin-top: 16px;
  }
`;

const Heading = styled.div`
${'' /* color: #005C87; */}
color: ${({ isColor }) => isColor ? isColor : "#005C87"};
text-align: center;
font-family: Lato;
font-size: 18px;
line-height: 24px;
display:flex;
width: 100%;
justify-content: center;
padding:16px;
border-bottom: 1px solid rgba(0, 92, 135, 0.30);
>img{
  margin-right: 12px;
}
`;


const HeadingV1 = styled.div`
${'' /* color: #005C87; */}
display:flex;
align-items:center;
justify-content: space-between;
color: ${({ isColor }) => isColor ? isColor : "#005C87"};
font-family: Lato;
font-size: 18px;
line-height: 24px;
display:flex;
width: 100%;
padding:0 0 16px;
>img{
  margin-right: 12px;
}

.icon{
  display:flex;
  margin-right: 4px;
}
`;

const HeadingBranding = styled.div`
color: #184A61;
font-family: Lato;
font-size: 18px;
font-weight: 700;
line-height: 24px;
text-align: left;
text-underline-position: from-font;
text-decoration-skip-ink: none;
display:flex;
width: 100%;
align-items:center;
.warning{
  width:32px;
  height:32px;
  display:flex;
  align-items:center;
  justify-content: center;
}
.close{
  width:32px;
  height:32px;
  display:flex;
  align-items:center;
  margin:auto 0px auto auto;
  justify-content: center;
  cursor:pointer
}
`;

export { Bold, StyledModal, SubmitContainer, StyledModalV2, BoldV2, Heading, HeadingBranding,HeadingV1 }